import { render, staticRenderFns } from "./AccordionGroupClasseEProduto.vue?vue&type=template&id=552acf58&scoped=true&"
import script from "./AccordionGroupClasseEProduto.vue?vue&type=script&lang=js&"
export * from "./AccordionGroupClasseEProduto.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroupClasseEProduto.vue?vue&type=style&index=0&id=552acf58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552acf58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('552acf58')) {
      api.createRecord('552acf58', component.options)
    } else {
      api.reload('552acf58', component.options)
    }
    module.hot.accept("./AccordionGroupClasseEProduto.vue?vue&type=template&id=552acf58&scoped=true&", function () {
      api.rerender('552acf58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/VisaoGeral/internalTemplates/AccordionGroupClasseEProduto.vue"
export default component.exports